import React, { useEffect, useCallback, useRef, useMemo, useState } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';
import Select from 'react-select';
import BulkUploadModal from './BulkUploadModal.js';
import EditLogsConsignments from './editlogsConsignments.js';
import CustomDialogForMasterEditLogs from './CustomDialogForMasterEditLogs.js';





function Masters() {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    var [rowData, setRowData] = useState([])
    var [columnDefs1, setColumnDefs1] = useState([
        {
            headerName: "Action",
            field: "_id",
            resizable: true,
            width: 90,
            filter: false,
            cellRenderer: EditItem,
            pinned: "left"
            // editable: false
        },
         {
                    headerName: "",
                    field: "edit_logs",
                    colId: "edit_logs",
                    width: 50,
                    pinned: "left",
                    filter:false,
                    cellRendererSelector: function (param) {
                        try {
                            if (param.data._id != null && param.data._id != undefined) {
                                // if(tabName.value === "active"){
                                    return {
                                        component: EditLogsConsignments,
                                        params: {
                                            onClickActive: onClickEditLogs,
                                            iconType: "edit",
                                            tooltip: "Edit Logs",
                                            disabled: (param.data.is_updated ===0 || param.data.is_updated === undefined || param.data.is_updated ===null)
        
                                        }
                                    // };                           
                                }
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    },
                    cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" },
                    headerClass: 'bold-header'
                },

    ])
    const locationMasterColumns = [
        {
            headerName: "City",
            field: "city",
            width: 240,
            filter: true,
        },
        {
            headerName: "State",
            field: "state",
            width: 240,
            filter: true,

        },
        {
            headerName: "Type",
            field: "type",
            width: 240,
            filter: true,
        },
        {
            headerName: "Type Name",
            field: "location_name",
            width: 240,
            filter: true,
        },
        {
            headerName: "Customer/Dealer Code",
            field: "location_code",
            width: 240,
            filter: true,
        },
        {
            headerName: "Address",
            field: "address",
            width: 240,
            filter: true,
        },
        {
            headerName: "Pincode",
            field: "pincode",
            width: 240,
            filter: true,
        },
        {
            headerName: "Latitude",
            field: "latitude",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',

            valueSetter: (params) => {
                const newValue = params.newValue;
                params.data.latitude = newValue; // Set the edited value directly to the data
                return true; // Return true to indicate successful update
            },

            valueFormatter: (params) => {
                return validateLatitudeLongitude(params.value); // Use validation function to format value
            },

            cellStyle: (params) => {
                const isValid = validateLatitudeLongitude(params.value) !== "Invalid Value";

                // If the value is invalid, apply a red background
                if (!isValid) {
                    return { backgroundColor: "#c85f62" }; // Light red background for invalid latitude
                }
                return null; // Default cell style for valid latitude values
            }
        },
        {
            headerName: "Longitude",
            field: "longitude",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',

            valueSetter: (params) => {
                const newValue = params.newValue;
                params.data.longitude = newValue; // Set the edited value directly to the data
                return true; // Return true to indicate successful update
            },

            valueFormatter: (params) => {
                return validateLatitudeLongitude(params.value); // Use validation function to format value
            },

            cellStyle: (params) => {
                const isValid = validateLatitudeLongitude(params.value) !== "Invalid Value";

                // If the value is invalid, apply a red background
                if (!isValid) {
                    return { backgroundColor: "#c85f62" }; // Light red background for invalid longitude
                }
                return null; // Default cell style for valid longitude values
            }
        },

        {
            headerName: "Zone",
            field: "zone",
            width: 240,
            filter: true,
        },
        {
            headerName: "Email",
            field: "email",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',

            valueSetter: (params) => {
                const newValue = params.newValue;
                params.data.email = newValue; // Set the edited value directly to the data
                return true; // Return true to indicate successful update
            },

            valueFormatter: (params) => {
                return validateEmail(params.value); // Use validation function to format value
            },

            cellStyle: (params) => {
                const isValid = validateEmail(params.value) !== "Invalid Email";

                // If the email is invalid, apply a red background
                if (!isValid) {
                    return { backgroundColor: "#c85f62" }; // Light red background for invalid email
                }
                return null; // Default cell style for valid email addresses
            }
        },

        {
            headerName: "Mobile Number",
            field: "mobile_number",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',

            valueSetter: (params) => {
                const newValue = params.newValue;

                // Ensure only 10 digits are allowed
                if (newValue.length > 10) {
                    params.data.mobile_number = newValue.substring(0, 10); // Trim to 10 digits if exceeded
                } else {
                    params.data.mobile_number = newValue;
                }
                return true; // Return true to indicate successful update
            },

            valueFormatter: (params) => {
                return validateMobileNumber(params.value); // Use validation function to format value
            },

            cellStyle: (params) => {
                const isValid = validateMobileNumber(params.value) !== "Invalid Mobile Number";

                // If the mobile number is invalid, apply a red background
                if (!isValid) {
                    return { backgroundColor: "#c85f62" }; // Light red background for invalid mobile number
                }
                return null; // Default cell style for valid mobile numbers
            }
        }


    ]
    var customerMasterColumns1 = [
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            width: 240,
            filter: true,
            resizable: true
        },

        {
            headerName: "Consignee Name",
            field: "consignee_name",
            width: 240,
            filter: true,
            editable: true,
            resizable: true

        },


        {
            headerName: "Mobile No.",
            field: "mobile_no",
            width: 240,
            filter: true,
            editable: true,
            resizable: true

        },
        {
            headerName: "Email Id",
            field: "email_id",
            width: 240,
            filter: true,
            editable: true,
            resizable: true,
        },
       

    ]
    var localStorageEmail = localStorage.getItem("email")
    


    var [columnDefs, setColumnDefs] = useState([...columnDefs1, ...customerMasterColumns1])

    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [uniqueId, setUniqueId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    var [error1, setError1] = useState("");
    var [error, setError] = useState("");

    var [customer, setCustomer] = useState({
        consigneeCode: '',
        consigneeName: '',
        mobileNo: '',
        emailId: '',
       
    })
    var [existingData, setExistingData] = useState({
        invoiceStartNo: '',
        invoiceSeries: '',
        invoiceSource: '',
        invoiceType: '',
        entity: '',
        category: ""
    })

    // var modules = useState(AllModules);
    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");
    var [deleteConfirmationSlide, setDeleteConfirmationSlide] = useState("");
    var [deleteRowData, setDeleteRowData] = useState("");
    var [invoiceLength, setInvoiceLength] = useState("");
    const [editLogsData, setEditLogsData] = useState([])
    const [filteredLog, setFilteredLog] = useState([])
    const [editLogsModalOpen, setIsEditLogsModalOpen] = useState(false)
    const [emailError, setEmailError] = useState('');
    const [mobileError, setMobileError] = useState('');
   

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable: true,
            sortable: true,
            filter: true,
            editable: false

        };
    }, []);

    var onGridReady = (params) => {
        // gridApi = params.api;
        // gridColumnApi = params.columnApi;
        // gridApiRef.current = params.api; 
        // gridColumnApiRef.current = params.columnApi;
    }

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };


    useEffect(() => {
        setTimeout(() => {
            // setshowloaderbg("show-n")
            setshowloader("show-n")
        }, 2000)
        loadData();

        // 
    }, [])
     const onClickEditLogs = (e) => {
            //console.log(e, "eeee1234");
           
            // setOrginalDetailsForEdit(e.data)
            var params = {
                unique_id: e.data._id,
                master_type:"customer"
            }
           
            // let selectedSource = e.data.source_city
            redirectURL.post("/consignments/getMasterEditLogsData", params)
            .then((response) => {
                if (response.data.status == 'Success') {
                    //console.log(response, "editlogsresp");
                    if((response.data.edit_logs_data).length>0){
                        setEditLogsData(response.data.edit_logs_data); // Store all logs
                    setFilteredLog(response.data.edit_logs_data[0]); // Default to first log
                    setIsEditLogsModalOpen(true);
                    }else{
                        setShow(true);
                        setTitle("No edit logs are currently available for this customer.");
                        setType("danger")
                        setoverlay("show-n")
                    }
                    
                }
            })
            .catch(function (e) {
                //console.log("Error ", e)
            })  
          
    
            // if(e.data.tracking_type === "FTL"){
            //     setshowAddForm3('slider-translate-30p');
            // } else {
            //     // setshowAddForm("slider-translate-30p");
            //     setshowAddForm3('slider-translate-30p');
            // }
            setoverlay("show-m");
        };

    var loadData = async () => {
        var parameters = {}
        await redirectURL.post('/getcustomerDetails', parameters)
            .then(response => {
                if (response.data.status == "success") {

                    setRowData(response.data.records);
                    // setInvoiceLength(response.data.records.length)

                }
                // setshowloaderbg("show-n");
                setshowloader("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
           
        
    }
    var onClickDeleteItem = async (rownode) => {
        // console.log("Rownode Update", rownode);
        setDeleteConfirmationSlide("slide95")
        setoverlay("show-m")
        setDeleteRowData(rownode)
    };

    var onsubmitdelete = async (rownode) => {
        // console.log("Rownode Update", rownode);
        var params = {
            row_id: deleteRowData.data._id
        }

        try {
            const resp = await redirectURL.post('/deleteLocationDetails', params);

            if (resp.data.status === "success") {
                setDeleteConfirmationSlide("")
                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("Invoice Deleted Successfully");
                setBasicType("success");
                loadData();
            }
        } catch (error) {
            console.error("Error deleting vehicle details:", error);
        }
    };
    var hideDeleteSubmit = () => {
        setDeleteConfirmationSlide("");
        setoverlay("show-n");

    }

    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add Customer");
        setCustomer({
            consigneeCode: '',
            consigneeName: '',
            mobileNo: '',
            emailId: ''
        })

        setIsEditMode(false);

    }

    var onClickEditBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m");
        setSliderText("Edit Customer");
        setUniqueId(rownode.data._id);
        setExistingData({
            consigneeCode: rownode.data.consignee_code,
            consigneeName: rownode.data.consignee_name,
            mobileNo: rownode.data.mobile_no,
            emailId: rownode.data.email_id,
        })

        setCustomer({
            consigneeCode: rownode.data.consignee_code,
            consigneeName: rownode.data.consignee_name,
            mobileNo:rownode.data.mobile_no,
            emailId: rownode.data.email_id,

        })

        setIsEditMode(true);
    }

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
    }
    const getChanges = () => {
        const changes = {}
        Object.keys(customer).forEach((key) => {
            if (customer[key] !== existingData[key]) {

                if (key === "consigneeCode") {
                    changes["consignee_code"] = customer[key]
                }
                if (key === "consigneeName") {
                    changes["consignee_name"] = customer[key]
                }
                if (key === "mobileNo") {
                    changes["mobile_no"] = customer[key]
                }
                if (key === "emailId") {
                    changes["email_id"] = customer[key]
                }
            }
        })
        return changes;
    }
    const getRemainingFields = (changedFields) => {
        const remainingFields = {};
        
        let data = {
            invoice_start_no:existingData.invoiceStartNo,
            invoice_source: existingData.invoiceSource,
            invoice_series : existingData.invoiceSeries,
            invoice_category: existingData.invoiceType,
            entity: existingData.entity,
            category: existingData.category
        }
        // Loop through all keys in 'existingData'
        Object.keys(data).forEach((key) => {
            if (!changedFields.hasOwnProperty(key)) {
                // Map the keys to the desired output format
                if (key === "invoice_start_no") {
                    remainingFields["invoice_start_no"] = existingData["invoiceStartNo"];
                }
                if (key === "invoice_series") {
                    remainingFields["invoice_series"] = existingData["invoiceSeries"];
                }
                if (key === "invoice_source") {
                    remainingFields["invoice_source"] = existingData["invoiceSource"];
                }
                if (key === "invoice_category") {
                    remainingFields["invoice_category"] = existingData["invoiceType"];
                }
                if (key === "entity") {
                    remainingFields["entity"] = existingData["entity"];
                }
                if (key === "category") {
                    remainingFields["category"] = existingData["category"];
                }
            }
        });

        return remainingFields;
    };



    var saveMasterForm = async (e) => {
        e.preventDefault();
        let user_email = localStorage.getItem('email');
        // setshowloaderbg("show-m");
        const createdDate = getCurrentISODate();
        if(emailError || mobileError){
            setShow(true);
            setBasicTitle("Please enter the valid values");
            setBasicType("danger");
            return;
        }

    

        setshowloader("show-m")
        if (isEditMode) {
            
            var changedFields = getChanges();
                // If either of these fields is not edited, pass only the edited fields
            var params = { ...changedFields };

            params.unique_id = uniqueId;
            params.master_type = "customer";
            params.email = decode(localStorageEmail)

            // params = {
            //     uniqueId: uniqueId,
            //     invoice_start_no:invoice.invoiceStartNo,
            //     invoice_series:invoice.invoiceSeries,
            //     invoice_source:invoice.invoiceSource,
            //     invoice_type:invoice.invoiceType,
            //     entity:invoice.entity,
            //     category:invoice.category,
            //     // is_active: is_active,
            //     modified_date: createdDate,
            //     master_type: "invoice"

            // }
        }

        else {
            var params = {
                consigneeCode: customer.consigneeCode,
                consigneeName: customer.consigneeName,
                mobileNo: customer.mobileNo,
                emailId: customer.emailId,
                // is_active: is_active,
                masterType: "customer",
                email:decode(localStorageEmail)
            }

        }

        if (isEditMode) {
            
            await redirectURL.post('/updateCustomerMaster', params).then((resp) => {
                if (resp.data.status == "Success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    setIsEditMode(false);
                    setUniqueId("");
                    setShow(true);
                    setBasicTitle(resp.data.message);
                    setBasicType("success");
                    loadData();
                    setCustomer({
                        consigneeCode: '',
                        consigneeName: '',
                        mobileNo: '',
                        emailId: ''
                    })
                   setMobileError("")
                   setEmailError("")
                }
            });
        } else {
            await redirectURL.post('/addCustomerMaster', params).then((resp) => {
                if (resp.data.status == "Success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    setShow(true);
                    setBasicTitle("Added Customer Data");
                    setBasicType("success");
                    loadData();
                    setCustomer({
                        consigneeCode: '',
                        consigneeName: '',
                        mobileNo: '',
                        emailId: ''
                    })

                    setIsEditMode(false);

                    setMobileError("")
                    setEmailError("")
                } else if (resp.data.status === "Failure") {
                    setoverlay("show-n");
                    setshowloader("show-n");
                    setIsEditMode(false);
                    setshowAddSlider("");
                    setShow(true);
                    setBasicTitle(resp.data.message);
                    setBasicType("danger");
                    setCustomer({
                        consigneeCode: '',
                        consigneeName: '',
                        mobileNo: '',
                        emailId: ''
                    })
                   
                    setMobileError("")
                    setEmailError("")
                }
            }).catch(err => {
            });
        }
    };
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const onClickOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
        setoverlay("show-m")
    };

    const closeBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        setoverlay("show-n")
    };



    
    const handleCloseModal = () => {
        setIsEditLogsModalOpen(false); // Close the modal
        setFilteredLog(null); // Clear filtered log
        setoverlay("show-n")
    };
    
    const handlePhoneInputChange = (e) => {
        const value = e.target.value;
        const isValidStart = /^[6-9][0-9]*$/;
    
        if (value === '' || (isValidStart.test(value) && value.length <= 10)) {
            setCustomer(prev => ({
                ...prev,
                mobileNo: value
            }));
    
            // Show error only if 1 to 9 digits entered
            if (value.length > 0 && value.length < 10) {
                setMobileError("Mobile number must be 10 digits.");
            } else {
                setMobileError("");
            }
        }
    };
    const handleEmailId = (e) => {
        const value = e.target.value;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|in)$/;
    
        setCustomer(prev => ({
            ...prev,
            emailId: value
        }));
        if (value && !emailRegex.test(value)) {
            setEmailError("Please enter a valid email ending with .com or .in");
        } else {
            setEmailError("");
        }
    };





    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                    }}>
                </SweetAlert>


            </div>
            <div className="container-fluid">
                {/* Row for Heading and Buttons */}
                <div className="row align-items-center justify-content-between mb-3">
                    {/* Heading */}
                    <div className="col-auto">
                        <h5 className="f18 d-flex align-items-center master-title">
                            <i className="icofont icofont-vehicle-delivery-van cus-i"></i>
                            &nbsp;Customer Master
                        </h5>
                    </div>

                    {/* Buttons */}
                    <div className="col-auto d-flex">
                        {/* <button
                title="Bulk Upload"
                onClick={onClickOpenBulkUploadModal}
                className="btn btn-warning mr-2"
                type="button"
                style={{ padding: "8px 15px", height: "35px" }}
            >
                <i className="fa fa-upload"></i>&nbsp;Upload Locations
            </button> */}

                        <BulkUploadModal
                            show={showBulkUploadModal}
                            onClose={closeBulkUploadModal}
                            columnDefs={locationMasterColumns}
                            screen={"location_master"}
                            templateUrl={require('../../assets/json/location_master_template.csv')}
                        />
                         <CustomDialogForMasterEditLogs
                                    isOpen={editLogsModalOpen}
                                    onClose={handleCloseModal}
                                    editLogsData={editLogsData}
                                    filteredLog={filteredLog}
                                    setFilteredLog={setFilteredLog}
                                />

                        {Constants.VEHICLES.BTN_ADD === 1 && (
                            <button
                                className="btn btn-warning"
                                onClick={showAddBlock}
                                style={{ padding: "8px 15px", height: "35px" }}
                            >
                                <i className="icon-plus"></i>&nbsp;Add Customer
                            </button>
                        )}
                    </div>
                </div>

                {/* Grid */}
                <div className="row">
                    <div className="col-xl-12 col-md-12 xl-60">
                        <div className="card">
                            <div className="card-body">
                                <div
                                    className="ag-theme-balham mt-3"
                                    style={{ height: "500px", width: "100%" }}
                                >
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={rowData}
                                        defaultColDef={defaultColDef}
                                        pagination={true}
                                        paginationPageSize={50}
                                        onGridReady={onGridReadyConsignments}
                                        enableRangeSelection={true}
                                        enableCellContextMenu={true}
                                        masterDetail={true}
                                        context={{ onClickEditBlock, onClickDeleteItem }}
                                        sideBar={{
                                            toolPanels: [
                                                {
                                                    id: "columns",
                                                    labelDefault: "Columns",
                                                    labelKey: "columns",
                                                    iconKey: "columns",
                                                    toolPanel: "agColumnsToolPanel",
                                                    toolPanelParams: {
                                                        suppressPivotMode: true,
                                                        suppressRowGroups: true,
                                                        suppressValues: true,
                                                    },
                                                },
                                                {
                                                    id: "filters",
                                                    labelDefault: "Filters",
                                                    labelKey: "filters",
                                                    iconKey: "filter",
                                                    toolPanel: "agFiltersToolPanel",
                                                },
                                            ],
                                        }}
                                        statusBar={{
                                            statusPanels: [
                                                {
                                                    statusPanel: "agTotalAndFilteredRowCountComponent",
                                                    align: "left",
                                                },
                                                {
                                                    statusPanel: "agTotalRowCountComponent",
                                                    align: "center",
                                                },
                                                { statusPanel: "agFilteredRowCountComponent" },
                                                { statusPanel: "agSelectedRowCountComponent" },
                                                { statusPanel: "agAggregationComponent" },
                                            ],
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className={"overlay-part " + (overlay)} onClick={hideAll}></div>

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                    <h4 className="slide-r-title">{sliderText}
                        <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>

                    </h4>

                </div>
                <div className="slide-r-body">

                    <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Consignee Code
                                {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                            <input type="text" name="consignee_code" value={customer.consigneeCode} style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {  // allows only digits (0-9)
                                    setCustomer(prevState => ({
                                        ...prevState,
                                        consigneeCode: value
                                    }));
                                }
                            }}
                                required={!isEditMode}
                                autoComplete='off'
                            />

                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Consignee Name
                                {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                            <input type="text" name="consignee_name" value={customer.consigneeName} style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                            }}
                            onChange={(e) => setCustomer(prevState => ({
                                ...prevState,
                                consigneeName: e.target.value
                            }))}
                           
                                required={!isEditMode}
                                autoComplete='off'
                            />

                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Mobile No.
                                {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                                <input
                                                        type="text"
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "4px",
                                                        }}
                                                        value={customer.mobileNo}
                                                        onChange={handlePhoneInputChange}
                                                        name="mobile_no"
                                                        autoComplete='off'
                                                        required={!isEditMode}
                                                        />
                                                    {mobileError && (
                                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                                {mobileError}
                                                            </span>
                                                            )}      
                          
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Email Id
                                {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                                <input
                                                        type="text"
                                                        style={{
                                                            width: "100%",
                                                            padding: "8px",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "4px",
                                                        }}
                                                        value={customer.emailId}
                                                        onChange={handleEmailId}
                                                        name="email_id"
                                                        autoComplete='off'
                                                        required={!isEditMode}
                                                        />
                                                            
                                  {emailError && (
                                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                                {emailError}
                                                            </span>
                                                            )}
                                    
                          
                        </div>
                       

                        




                        {isEditMode ?
                            <>
                                <div className="form-group" style={{ textAlign: "center" }}>
                                    <button type="submit" className="btn btn-success"
                                        style={{
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "4px",
                                            backgroundColor: "#28a745",
                                            color: "white",
                                        }}
                                    >Update Customer</button>
                                </div>
                            </>
                            :
                            <>
                                <div className="form-group" style={{ textAlign: "center" }}>
                                    <button type="submit" className="btn btn-success"
                                        style={{
                                            padding: "10px 20px",
                                            border: "none",
                                            borderRadius: "4px",
                                            backgroundColor: "#28a745",
                                            color: "white",
                                        }}
                                    >Add Customer</button>
                                </div>
                            </>
                        }
                        {/* <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Transporter</button>
                        </div> */}

                    </form>
                </div>

            </div>
            {deleteConfirmationSlide
                &&
                <div className={"sliderBlock3 " + (deleteConfirmationSlide)} >
                    <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeleteSubmit} >
                        <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                    </span>
                    <div className='d-flex mt-60p' style={{ marginLeft: "42px" }}>
                        <div className='d-flex flex-column ml-20p'>
                            <h1 className='confirm-heading'>Are you sure you want to delete ?</h1>
                        </div>
                    </div>
                    <div className='d-flex flex-row ml-30p mt-20p'>
                        <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeleteSubmit} >Cancel</button>
                        <button className='btn_hover8' onClick={onsubmitdelete}>Delete</button>
                    </div>

                </div>}

            <div className={"dataLoadpage " + (showloader)}>
            </div>
            <div className={"dataLoadpageimg " + (showloader)}>
                <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overlay)} style={{ zIndex: "10" }}
            ></div>

        </div>
    );
}




export default Masters;
